import React, { useCallback, useEffect, useState } from "react";
import styles from "../MainPage/common/styles";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    TextField,
    Autocomplete,
} from "@mui/material";
import { selectedHouse } from "../redux/action/deviceDropdownSelection";
import { fetchHouseDetails } from "../redux/action/house";
import { allTypeOfDevices } from "./function";
import EnergiSync from "./Component/energiSync";
import ThermoSmarts from "./Component/thermoSmarts";
import WeatherSensors from "./Component/weatherSensors";
import EnvironSyncs from "./Component/environSyncs";
import DoorSensor from "./Component/DoorSensor";
import PropertySummary from "./Component/PropertySummary";
import Loading from "../common/Loading";
import Header from "../Header/Header";
import { config } from "../../config";
import { useNavigate } from "react-router-dom";


// A device takes part in the property total only if it shows one of these.
const SAVINGS_SYSTEM_VALUES = ["unitSaved", "unitSaving", "saving"];

function DashBoard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const houseData = useSelector((state) => state.houseData);
    const housesList = useSelector((state) => state.housesList);
    const login = useSelector((state) => state.login);
    const { houseId, selectedDeviceDetails, roomId, devices } = useSelector(
        (state) => state.dropdownSelectionData || {}
    );
    const [allDevices, setAllDevices] = useState([]);
    const [loading, setLoading] = useState(false);
    // Each meter card computes its own totals, so the property wide figures are collected
    // from them as they report in rather than recalculated here.
    const [deviceTotals, setDeviceTotals] = useState({});

    const handleDeviceTotals = useCallback((deviceId, totals) => {
        setDeviceTotals((previous) => {
            const current = previous[deviceId];

            if (
                current?.unitsSaved === totals.unitsSaved &&
                current?.unitsConsumed === totals.unitsConsumed
            ) {
                return previous;
            }

            return { ...previous, [deviceId]: totals };
        });
    }, []);

    const reportedTotals = Object.values(deviceTotals);
    const totalUnitsSaved = reportedTotals.reduce((total, device) => total + device.unitsSaved, 0);
    const totalUnitsConsumed = reportedTotals.reduce((total, device) => total + device.unitsConsumed, 0);
    const handleNavgation = (allDevicesData) => {
            const houseInfoFind = allDevicesData.reduce((prv,cur)=>{
            if(cur?.homePageInfo && cur?.homePageInfo?.length > 0){
               return 1
            }
            return prv
        },0)
        if(houseInfoFind === 0){
            navigate('/dashboard')
        }
    }
    const handleHouseChange = async (event) => {
        setLoading(true)
        setAllDevices([])
        setDeviceTotals({})
        const selectedHouseID = event.target.value;
        dispatch(selectedHouse(selectedHouseID));
        const loginDetails = login;

        const mobileWithoutCountryCode = loginDetails.profile.mobile.slice(3);

        await fetchHouseDetails(selectedHouseID, mobileWithoutCountryCode).then((res) => {
            // Filter rooms that have devices
            const roomsWithDevices = res?.data?.rooms?.filter(
                room => room?.energiSync.length > 0 ||
                    room?.weatherSensors.length > 0 ||
                    room?.thermoSmarts.length > 0 ||
                    room?.environSyncs.length > 0 ||
                    room?.doorSensors.length > 0
            );

            // Get all devices from all rooms
            const alldevices = allTypeOfDevices(roomsWithDevices);
             handleNavgation(alldevices)
            setAllDevices(alldevices)
            setLoading(false)
        })

    }
    useEffect(() => {
        if (houseData) {
            // Filter rooms that have devices
            const roomsWithDevices = houseData?.rooms?.filter(
                room => room?.energiSync.length > 0 ||
                    room?.weatherSensors.length > 0 ||
                    room?.thermoSmarts.length > 0 ||
                    room?.environSyncs.length > 0 ||
                    room?.doorSensors.length > 0
            );

            // Get all devices from all rooms
            const alldevices = allTypeOfDevices(roomsWithDevices);
            handleNavgation(alldevices)
            setAllDevices(alldevices)
        }
    }, [])

    let ppu =
        houseData.ppu !== undefined && houseData.ppu > 0 ? houseData.ppu : 15;
    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
        }}>
            {/* <SideBar /> */}
            <div style={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <Header />
                <div style={styles.container}>
                    {loading && <Loading />}
                    <PropertySummary
                        deviceCount={reportedTotals.length}
                        unitsSaved={totalUnitsSaved}
                        unitsConsumed={totalUnitsConsumed}
                    >
                        <Box sx={{ minWidth: 120 }}>
                            <Autocomplete
                                id="house-select"
                                options={housesList.sort((a, b) =>
                                    a.houseName
                                        .toLowerCase()
                                        .localeCompare(b.houseName.toLowerCase())
                                )}
                                getOptionLabel={(option) => option.houseName || ""}
                                value={housesList.find(house => house.houseAccessCode === houseId) || null}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        handleHouseChange({ target: { value: newValue.houseAccessCode } });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Property"
                                        placeholder="Search properties..."
                                    />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                    option.houseAccessCode === value.houseAccessCode
                                }
                            />
                        </Box>
                    </PropertySummary>


                    <Row className="row g-4">
                        {allDevices.length > 0 && allDevices.map((device, index) => {
                            // Map device type strings to actual components
                            const componentMap = {
                                'energiSync': EnergiSync,
                                'thermoSmarts': ThermoSmarts,
                                'weatherSensors': WeatherSensors,
                                'environSyncs': EnvironSyncs,
                                'doorSensors': DoorSensor
                            };

                            const DeviceComponent = componentMap[device.type];

                            // Make System values component
                            const systemValuesComponent = device?.homePageInfo ? device.homePageInfo.reduce((prv,cur)=>{
                                if(cur.dataType===config.typeOfConfigration.systemValues){
                                    return [...prv,cur?.valueType]
                                }
                                return prv
                            },[]) : []
                            if(systemValuesComponent.length===0){
                                return null
                            }
                            // Only meters that actually report savings feed the header total.
                            // Temperature sensors and the like show none, so counting them
                            // would inflate the meter count and dilute the overall saving.
                            const reportsSavings = systemValuesComponent.some((value) =>
                                SAVINGS_SYSTEM_VALUES.includes(value)
                            );
                            return DeviceComponent ? (
                                <Col md={6} sm={12} key={index}>
                                    <DeviceComponent device={device} ppu={ppu} houseId={houseId} systemValuesComponent={systemValuesComponent} onTotals={reportsSavings ? handleDeviceTotals : undefined}/>
                                </Col>
                            ) : null;
                        })}
                    </Row>

                    <div style={{ height: '150px' }}></div>
                </div>
            </div>
        </div>
    )
}

export default DashBoard